/**
 * Synthetic filter value for the status dropdown: show only archived (closed) matters/projects.
 */
export const ARCHIVED_STATUS_FILTER_VALUE = "__archived__" as const;

/**
 * Whether a matter/project should be treated as archived: hidden from the default "All Statuses"
 * list and shown when the user selects "Archived".
 *
 * Matches terminal workflow statuses used in the app (see MattersTable STATUS_OPTIONS).
 */
export function isArchivedMatterStatus(status: string | undefined): boolean {
  if (!status) return false;
  const s = status.trim().toLowerCase();
  if (
    s === "complete" ||
    s === "completed" ||
    s === "cancelled" ||
    s === "canceled" ||
    s === "closed"
  ) {
    return true;
  }
  return false;
}

/** Minimal row shape for archive checks (matters list + projects list). */
export interface MatterArchiveRow {
  status?: string;
  progress?: number | string | null;
}

/**
 * Archived / finished: **progress ≥ 100%** (closed/finished), or terminal status
 * (Complete / Cancelled / Closed) when status alone indicates done.
 */
export function isArchivedMatter(row: MatterArchiveRow): boolean {
  if (isArchivedMatterStatus(row.status)) return true;
  const p = row.progress;
  if (p === undefined || p === null || p === "") return false;
  const n = typeof p === "number" ? p : parseFloat(String(p));
  if (Number.isNaN(n)) return false;
  return n >= 100;
}
